module.exports = __webpack_public_path__ + "img/icon-microsoftedge.12d045ac.svg";